<template>
  <div>
    <el-row :gutter="10" style="margin:10px;display:flex;align-items:center;">
      <el-col :span="2">
          <label>{{$t('surong.grouping')}}:</label>
      </el-col>
      <el-col :span="3" >
          <el-select  size="small" class="dialog_item_element" v-model="selectedCuptypeGroup" :placeholder="$t('surong.pleaseSelectAGroup')" >
            <el-option :label="$t('surong.total')" :value="null"></el-option>
            <el-option v-for="(item,index) in cuptypeGroupList" :key="index" :label="item" :value="item"></el-option>
          </el-select>
      </el-col>
      <el-col :span="1">
          <el-button type="primary" size="small" @click="query"><i class="el-icon-search el-icon--left"></i>{{$t('search')}}</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
          <el-table
            ref="multipleTable"
            :data="cupTypeList"
            :row-key="rowkey"
            :stripe="true"
            tooltip-effect="dark"
            :page-size="cupTypePageSize"
            :pager-count="11"
            max-height="520"
            v-loading="tableloading"
            @selection-change="handleSelection"
            @select-all="handleSelection"
            >
            <el-table-column
              type="selection"
              >
            </el-table-column>
            <el-table-column
              type="index"
              :label="$t('serialNo')"
              width="100">
            </el-table-column>
            <el-table-column
              prop="DrinkName"
              :label="$t('beverageName')"
              >
              <template slot-scope="scope">
                <label>{{scope.row.beverage?scope.row.beverage.name:""}}</label>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('beverageImage')"
              >
              <template slot-scope="scope">
                <el-image style="width: 100px; height: 100px" fit="fill" class="img" v-if="scope.row.beverage.picture" :src="scope.row.beverage.picture.path"></el-image>
                <label v-else>{{$t('noPicture')}}</label>
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('surong.ingredientName')"
              >
              <template slot-scope="scope">
                <label v-for="(item,index) in scope.row.beverage.rawMaterials" :key="index">{{item?item.name:""}}&nbsp;</label>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('surong.category')"
              >
              <template slot-scope="scope">
                    <label v-if="scope.row.beverage&&scope.row.beverage.beverageCatalog==1">{{$t('surong.coffee')}}</label>
                    <label v-if="scope.row.beverage&&scope.row.beverage.beverageCatalog==2">{{$t('surong.milkTea')}}</label>
                    <label v-if="scope.row.beverage&&scope.row.beverage.beverageCatalog==3">{{$t('surong.soybeanMilk')}}</label>
                    <label v-if="scope.row.beverage&&scope.row.beverage.beverageCatalog==4">{{$t('surong.juice')}}</label>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('surong.cupType')"
              >
              <template slot-scope="scope">
                <label v-if="scope.row.cupSize">{{scope.row.cupSize.name}}</label>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('selectedImage')"
            >
              <template slot-scope="scope">
                <el-image style="width: 100px; height: 100px" fit="fill"  class="img" v-if="scope.row.checkedPicture" :src="scope.row.checkedPicture.path"></el-image>
                <label v-else>{{$t('noPicture')}}</label>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('notSelectedImage')"
            >
              <template slot-scope="scope">
                <el-image style="width: 100px; height: 100px" fit="fill" class="img" v-if="scope.row.unCheckedPicture" :src="scope.row.unCheckedPicture.path"></el-image>
                <label v-else>{{$t('noPicture')}}</label>
              </template>
            </el-table-column>

          </el-table>
      </el-col>
    </el-row>
    <el-row>
        <el-col :span="24" style="margin-top:2%;text-align:right;">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20,50,100]"
            :page-size="cupTypePageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="cupTypeTotalCount">
        </el-pagination>
        </el-col>
    </el-row>
    <div style="margin-top:10px;" v-if="allselectedCupTypeList.length>0">
        <el-row :gutter="20" style="margin-bottom:10px;">
            <el-col :span="6"><label style="font-size:18px">{{$t('surong.selectedRecipes')}}：</label></el-col>
        </el-row>
        <el-tag style="margin:5px" v-for="(item, index) in allselectedCupTypeList" :key="index" type="warning" closable @close="handleClose(item)">{{item.beverage.name}}<span v-if="item.cupSize">-{{item.cupSize.name}}</span></el-tag>
    </div>


  </div>
</template>

<script>
export default {
     props:{
        initvalue:0,
    },
    watch:{
        initvalue(val, oldVal){//普通的watch监听
            if(val!=oldVal){
              this.currentPage = 1
              this.init();
              this.loadCupGroups(this.initvalue);
            }
        }
    },
    data(){
        return {
            selectedCuptypeGroup:null,
            cuptypeGroupList:[],
            cupTypePageSize:10,
            cupTypeList:[],
            cupTypeTotalCount:0,
            tableloading:true,
            currentPage:1,
            selectedCupTypeList:[],
            allselectedCupTypeList:[],
            lastselectedCupTypeList:[],
        }
    },
    mounted(){
        // this.loadCupTypes(1);
        this.loadCupGroups(this.initvalue);
    },
    methods:{
        rowkey(row){
          return row.id
        },
        query(){
          this.loadCupTypes(1,{cupTypeGroupName:this.selectedCuptypeGroup});
        },
        //获取已选择
        handleSelection (selection) {
          this.selectedCupTypeList=selection
          this.allselectedCupTypeList = this.lastselectedCupTypeList.concat(this.selectedCupTypeList)
          // this.allselectedCupTypeList = Array.from(new Set(arry))
        },
        loadCupGroups(typeid){
          if(typeid){
            let that = this;
            this.$httpservice.get("api/Beverage/CupTypeGroups?equipmentTypeId="+typeid).then(
              function (data) {
                  if(data.body.code=="200"){
                      that.cuptypeGroupList = data.body.data;
                  }else{
                      that.$message({
                          message: data.body.msg,
                          type: 'warning'
                      });
                  }
              },
              function (data) {
                  let statusCode = data.status;
                  that.$message({
                      message: that.$t('queryFailedStatusCode')+statusCode,
                      type: 'warning'
                  });
              }
            );
          }else{
            let that = this;
            this.$httpservice.get("api/Beverage/CupTypeGroups").then(
              function (data) {
                  if(data.body.code=="200"){
                      that.cuptypeGroupList = data.body.data;
                      console.log(that.cuptypeGroupList)
                  }else{
                      that.$message({
                          message: data.body.msg,
                          type: 'warning'
                      });
                  }
              },
              function (data) {
                  let statusCode = data.status;
                  that.$message({
                      message: that.$t('queryFailedStatusCode')+statusCode,
                      type: 'warning'
                  });
              }
            );
          }

        },
        init(){
          this.selectedCupTypeList = [];
          // this.loadCupTypes(1);
        },
        handleClose(e){
          if(this.selectedCupTypeList.indexOf(e)>-1){
            this.$refs.multipleTable.toggleRowSelection(e);
          }else{
            let index1 = this.allselectedCupTypeList.indexOf(e)
            this.allselectedCupTypeList.splice(index1,1)
            let index2 = this.lastselectedCupTypeList.indexOf(e)
            this.lastselectedCupTypeList.splice(index2,1)
          }
        },
        loadCupTypes(pageIndex,otherParam){
            let that = this;
            this.tableloading = true;

            let finalParam = {
              pageIndex:pageIndex,
              pageSize:this.cupTypePageSize,
              ...otherParam
            }
            this.$httpservice.get("api/Beverage/CupTypes",finalParam).then(
              function (data) {
                  if(data.body.code=="200"){
                      that.tableloading = false;
                      that.cupTypeList = data.body.data;
                      that.cupTypeTotalCount = data.body.totalCount;

                      that.selectedCupTypeList = []
                      that.lastselectedCupTypeList = []
                      let l = []
                      for(let i in that.allselectedCupTypeList){
                        let f = data.body.data.find(item=>{
                          return item.id ==  that.allselectedCupTypeList[i].id
                        })
                        if(f){
                          that.selectedCupTypeList.push(f)
                          l.push(f)
                        }else{
                          that.lastselectedCupTypeList.push(that.allselectedCupTypeList[i])
                        }
                      }
                      that.allselectedCupTypeList = []
                      setTimeout(()=>{
                        for(let i in l){
                          that.$refs.multipleTable.toggleRowSelection(l[i]);
                        }
                      },0)


                  }else{
                      that.$message({
                          message: data.body.msg,
                          type: 'warning'
                      });
                  }
              },
              function (data) {
                  that.Beverageloading= false;
                  let statusCode = data.status;
                  that.$message({
                      message: that.$t('queryFailedStatusCode')+statusCode,
                      type: 'warning'
                  });
              }
            );
        },
        handleSizeChange(e){
            this.cupTypePageSize = e;
            this.currentPage = 1
            this.loadCupTypes(1,{equipmentTypeId:this.initvalue});
        },
        handleCurrentChange(e){
            this.currentPage = e
            this.loadCupTypes(e,{equipmentTypeId:this.initvalue});
        }


    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/beveragearrange/SelectCupTypeListComponent.vue